export default "__VITE_ASSET__SPLFiydA__"